export default __webpack_public_path__ + "static/media/cp.97fed407.svg";